/**
 * The `data-testid` values of the low-resolution warning on a canvas image
 * item: the icon in the item's warning bar, the tooltip it opens, and the
 * tooltip's link into the Enhance flow. `LowResolutionWarning` draws them
 * from here and its tests import them from here.
 */
export const ITEM_LOW_RES_TEST_IDS = {
  BADGE: 'item-low-res-badge',
  TOOLTIP: 'item-low-res-tooltip',
  ENHANCE: 'item-low-res-enhance',
} as const
